import { observable, action, computed, createTransformer, reaction } from "mobx";
import JustificativaContratoService from "../../../services/JustificativaContratacaoService";

export default class JustificativaContratacaoStore {

    @observable justificativaList;
    @observable itemSelecionado;
    @observable loading;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.justificativaList = [];
        this.resetItemSelecionado();
        this.justificativaContratacaoService = new JustificativaContratoService()
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            nome: "",
            descricao: "",
            eventoImprevisivel: null,
            exigeAprovacaoDiretor: true,
            justificativaAlocavel: null,
            podeAlterarJustificativa: true,
            obrigatorioAlterar: false,
            possuiFatoGerador: null,
            produtoOracle: false,
            classificacaoRisco: "",
            motivoContratacao: null,
            contRenovDiasMax: 270,
            curtoIniSolicDiasMax: 10,
            curtoIniSolicDiasMin: 3,
            funcSubsSemAprovMax: null,
            funcionariosSubstituidosMax: null,
            funcionariosSubstituidosMin: null,
            iniSolicIdealDiasMax: 30,
            iniSolicIdealDiasMin: 11,
            prorrogacaoDiasMax: 90,
            prorrogacaoDiasMin: 30,
            recursosSolicMotMax: 30,
            recursosSolicMotMin: 1,
            renovPeriodoAdiDiasMax: null,
            renovPeriodoIniDiasMax: null,
            solicContratacaoDiasMax: 180,
            solicContratacaoDiasMin: 30,
            solicSubstituicaoDiasMax: null,
            solicSubstituicaoDiasMin: null,
            solicTerminoAnteDiasMin: 20,
            substituicoesPermitidasMax: null,
            anteProrrogacaoDiasMin: null,
            prorrogacoesPermitidasMax: 1,
            ativo: true
        };
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.justificativaContratacaoService.list().then(response => {
                this.justificativaList = response.data;
            }).catch(error => {
                console.log(error);
            })
        ])
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    toggleAtivo() {
        this.itemSelecionado.ativo = !this.itemSelecionado.ativo;
    }

    toggleAlteraNaRenovacao() {
        this.itemSelecionado.podeAlterarJustificativa = !this.itemSelecionado.podeAlterarJustificativa;
    }

    toggleObrigatorioAlterar(){
        this.itemSelecionado.obrigatorioAlterar = !this.itemSelecionado.obrigatorioAlterar;
    }

    toggleFatoGerador() {
        this.itemSelecionado.possuiFatoGerador = !this.itemSelecionado.possuiFatoGerador;
    }

    toggleProdutoOracle() {
        this.itemSelecionado.produtoOracle = !this.itemSelecionado.produtoOracle;
    }

    toggleNecessarioInformarProduto() {
        this.itemSelecionado.necessarioInformarProduto = !this.itemSelecionado.necessarioInformarProduto;
    }

    toggleEventoImprevisivel() {
        this.itemSelecionado.eventoImprevisivel = !this.itemSelecionado.eventoImprevisivel;
    }

    setExigeAprovacaoDiretor(value) {
        this.itemSelecionado.exigeAprovacaoDiretor = value;
    }

    setNome(value) {
        this.itemSelecionado.nome = value;
    }

    setDescricao(value) {
        this.itemSelecionado.descricao = value;
    }

    setMotivo(value) {
        this.itemSelecionado.motivoContratacao = value;
    }

    setClassificacaoRisco(value) {
        this.itemSelecionado.classificacaoRisco = value;
    }

    setIsAlocavel(value) {
        this.itemSelecionado.justificativaAlocavel = value;
    }

    setCampoJustificativaInteiro(campo, value) {
        this.itemSelecionado[campo] = parseInt(value);
    }

    setLista(value) {
        this.justificativaList = value;
    }


    preencherModal(row){
        if(row) {
            this.itemSelecionado = Object.assign({}, row);
        } else {
            this.resetItemSelecionado();
        }
    }

    editar() {
        let tabelaIndex = this.justificativaList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);

        return this.justificativaContratacaoService.edit(this.itemSelecionado.id, this.itemSelecionado).then(response =>  {
            this.justificativaList[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        return this.justificativaContratacaoService.save(this.itemSelecionado).then(response => {
            this.justificativaList.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.justificativaList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.justificativaContratacaoService.delete(this.itemSelecionado.id).then(response => {
            this.justificativaList.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        })
    }


}